import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class PersonneMoraleCession extends DivContainer {
	static properties = {
		showCapital: {
			type: Boolean, attribute: "show-capital", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	}
	
  	constructor() {
	    super();
		this.showCapital = false;
	    this.content = () => html`
		<row-wrapper>
			<text-field label="Dénomination *" required name="denomination"></text-field>
		</row-wrapper>
		<row-wrapper>
			<select-from-api label="Forme juridique *" api-url="${window.APP_URL.api.legalForm}" required value="0"
				null-option-text="Forme Juridique" null-option-value="0" name="id_legal_form" discard-legal-form="true"></select-from-api>
		</row-wrapper>
		${this.showCapital
		    ? html`
		        <row-wrapper>
		          <number-field label="Capital social *" required name="share_capital"></text-field>
		        </row-wrapper>
		      `
		    : ""}
		<row-wrapper>
			<text-field label="Adresse *" required name="address"></text-field>
		</row-wrapper>
		<autocomplete-ville></autocomplete-ville>
		<rcs-number-field></rcs-number-field>
		<row-with-tooltip tooltip-text="La ville du greffe dépend de l'adresse de siège social." >
			<text-field label="Greffe" name="greffe"></text-field>
		</row-with-tooltip>
	    `;
	}
}

customElements.define ("personne-morale-cession", PersonneMoraleCession);
